// BASED ON FIGMA LAYOUTS 375 x 667
export const getVW = (number: number) => {
	return `${Math.round((number / 375) * 100 * 100) / 100}vw`;
};
export const getVH = (number: number) => {
	return `${Math.round((number / 667) * 100 * 100) / 100}vh`;
};
